<template>
  <div class="main-title has-tab">
    <!-- 标题 -->
    <div class="title-name">
      <img :src="titleImg" alt />
      <span class="title-name-title">{{ title }}</span>
      <!-- tab切换 -->
      <div class="title-tab" v-if="tabOption.length > 0">
        <span
          v-for="(item, index) in tabOption"
          :key="index"
          class="tab-item"
          :class="index === tabIndex ? 'active' : ''"
          @click="tabSelect(item, index)"
        >
          {{ item.title }}
        </span>
      </div>
    </div>
    <!-- 查看更多 -->
    <div class="title-more" @click="seeMore">
      <span>查看更多</span>
      <img src="../../../assets/icon_more.png" alt />
    </div>
  </div>
</template>
<script>
export default {
  name: "MainTitle",
  data() {
    return {
      tabIndex: 0
    }
  },
  props: {
    titleImg: {
      default: "",
      required: true
    },
    path: {
      default: "",
      required: true
    },
    title: {
      default: "",
      required: true
    },
    tabOption: {
      type: Array,
      default: () => []
    },
  },
  computed: {},
  mounted() {},
  methods: {
    /** @name 查看更多 */
    seeMore() {
      if (this.path === "course/list") {
        window.open(`${process.env.VUE_APP_VIDEODETAIL}${this.path}`)
      } else {
        this.$router.push(this.path)
      }
    },
    /** @name tab选项点击方法 */
    tabSelect(item, index) {
      this.tabIndex = index
      this.$emit("tabSelect", item)
    }
  }
}
</script>
<style lang="scss" scoped>
.main-title {
  background: #ffffff;
  width: 1200px;
  margin: 10px auto 0;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  line-height: 44px;
  .title-name {
    font-size: 20px;
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-left: 20px;
    }
    .title-name-title {
      margin-left: 10px;
      color: #b79255;
      font-weight: bold;
      font-size: 22px;
    }
  }
  .title-more {
    margin-right: 20px;
    font-size: 14px;
    color: #666;
    cursor: pointer;
    img {
      width: 14px;
      height: 14px;
      margin-left: 4px;
      vertical-align: middle;
      position: relative;
      top: -1px;
    }
  }
}
.has-tab {
  border-bottom: 1px solid #e4e7ed;
  .title-name {
    width: 1050px;
    font-size: 20px;
    display: flex;
    align-items: center;
    img {
      width: 30px;
      height: 30px;
      margin-left: 20px;
    }
    .title-name-title {
      margin-left: 10px;
      color: #b79255;
    }
    .title-tab {
      margin-left: 50px;
      font-size: 16px;
      color: #333333;
      .tab-item {
        cursor: pointer;
        margin-left: 40px;
        &:first-child {
          margin-left: 0;
        }
      }
      .active {
        // color: #0286df;
        color: #e1251b;
        position: relative;
        font-weight: bold;
      }
      .active:after {
        display: block;
        content: "";
        width: 100%;
        height: 2px;
        // background: #0286df;
        background: #e1251b;

        position: absolute;
        margin-top: -1px;
        left: 0;
        right: 0;
      }
    }
  }
}
</style>
